
export const defaultLayoutOrder = [
  'heroBanner',
  'featuredCarousel',
  'browseByMake',
  'browseByCategory',
  'contactFormSection',
]
